import { css as m, LitElement as f, html as s, nothing as l } from "lit";
import { query as u, property as i, customElement as g } from "lit/decorators.js";
import { classMap as y } from "lit/directives/class-map.js";
import { b } from "./styles-scZ6dVz-.js";
import { b as h, a as v } from "./events-CkEPl0SM.js";
import { t as w, a as x } from "./a11y-DxQW21Jt.js";
var E = Object.defineProperty, C = Object.getOwnPropertyDescriptor, o = (e, a, d, n) => {
  for (var r = n > 1 ? void 0 : n ? C(a, d) : a, c = e.length - 1, p; c >= 0; c--)
    (p = e[c]) && (r = (n ? p(a, d, r) : p(r)) || r);
  return n && r && E(a, d, r), r;
};
let t = class extends f {
  constructor() {
    super(...arguments), this.open = !1, this.size = "md", this.showClose = !0, this.closeOnOverlay = !0, this.closeOnEscape = !0, this.handleKeydown = (e) => {
      e.key === "Escape" && this.closeOnEscape && (e.preventDefault(), this.hide());
    };
  }
  /** Open the dialog */
  show() {
    this.open = !0;
  }
  /** Close the dialog */
  hide() {
    this.open = !1;
  }
  handleOpen() {
    this.previousActiveElement = document.activeElement, document.body.style.overflow = "hidden", this.updateComplete.then(() => {
      if (this.dialogElement) {
        this.cleanupFocusTrap = w(this.dialogElement);
        const e = x(this.dialogElement);
        e.length > 0 ? e[0].focus() : this.dialogElement.focus();
      }
    }), this.closeOnEscape && document.addEventListener("keydown", this.handleKeydown), h(this, v.OPEN);
  }
  handleClose() {
    document.body.style.overflow = "", this.cleanupFocusTrap?.(), this.cleanupFocusTrap = void 0, this.previousActiveElement?.focus(), this.previousActiveElement = void 0, document.removeEventListener("keydown", this.handleKeydown), h(this, v.CLOSE);
  }
  handleOverlayClick(e) {
    e.target === this.overlayElement && this.closeOnOverlay && this.hide();
  }
  handleCloseClick() {
    this.hide();
  }
  updated(e) {
    e.has("open") && (this.open ? this.handleOpen() : e.get("open") === !0 && this.handleClose());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.cleanupFocusTrap?.(), document.removeEventListener("keydown", this.handleKeydown), document.body.style.overflow = "";
  }
  render() {
    const e = {
      overlay: !0,
      open: this.open,
      [this.size]: !0
    }, a = s`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
      </svg>
    `;
    return s`
      <div
        part="overlay"
        class=${y(e)}
        @click=${this.handleOverlayClick}
        aria-hidden=${!this.open}
      >
        <div
          part="dialog"
          class="dialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby=${this.dialogTitle ? "dialog-title" : l}
          aria-describedby=${this.description ? "dialog-description" : l}
          tabindex="-1"
        >
          ${this.dialogTitle || this.showClose ? s`
                <header part="header" class="header">
                  <div class="header-content">
                    <slot name="header">
                      ${this.dialogTitle ? s`<h2 part="title" id="dialog-title" class="title">${this.dialogTitle}</h2>` : l}
                      ${this.description ? s`<p part="description" id="dialog-description" class="description">${this.description}</p>` : l}
                    </slot>
                  </div>
                  ${this.showClose ? s`
                        <button
                          part="close"
                          class="close"
                          type="button"
                          aria-label="Close dialog"
                          @click=${this.handleCloseClick}
                        >
                          ${a}
                        </button>
                      ` : l}
                </header>
              ` : l}

          <div part="content" class="content">
            <slot></slot>
          </div>

          <footer part="footer" class="footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
  }
};
t.styles = [
  b,
  m`
      :host {
        display: contents;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .overlay {
        position: fixed;
        inset: 0;
        z-index: var(--r5-z-overlay);
        background-color: var(--r5-bg-overlay);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--r5-space-4);
        opacity: 0;
        visibility: hidden;
        transition: opacity var(--r5-duration-normal) var(--r5-ease-default),
                    visibility var(--r5-duration-normal) var(--r5-ease-default);
      }

      .overlay.open {
        opacity: 1;
        visibility: visible;
      }

      .dialog {
        position: relative;
        display: flex;
        flex-direction: column;
        max-height: calc(100vh - var(--r5-space-8));
        background-color: var(--r5-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--radius, var(--r5-radius-xl));
        box-shadow: var(--r5-shadow-popover, var(--r5-shadow-xl));
        color: var(--r5-text);
        font-family: var(--r5-font-body);
        transform: scale(0.95) translateY(10px);
        transition: transform var(--r5-duration-normal) var(--r5-ease-out);
        overflow: hidden;
      }

      .overlay.open .dialog {
        transform: scale(1) translateY(0);
      }

      /* Sizes */
      .sm .dialog {
        width: 100%;
        max-width: 24rem;
      }

      .md .dialog {
        width: 100%;
        max-width: 32rem;
      }

      .lg .dialog {
        width: 100%;
        max-width: 42rem;
      }

      .xl .dialog {
        width: 100%;
        max-width: 56rem;
      }

      .full .dialog {
        width: calc(100% - var(--r5-space-8));
        max-width: none;
        height: calc(100% - var(--r5-space-8));
      }

      /* Header */
      .header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--r5-space-4);
        padding: var(--r5-space-6);
        padding-bottom: 0;
      }

      .header-content {
        flex: 1;
        min-width: 0;
      }

      .title {
        font-size: var(--r5-text-lg);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        margin: 0;
        line-height: var(--r5-leading-tight);
      }

      .description {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        margin: var(--r5-space-1) 0 0 0;
      }

      /* Close button */
      .close {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        margin: -0.25rem -0.25rem 0 0;
        padding: 0;
        border: none;
        background: transparent;
        color: var(--r5-text-muted);
        cursor: pointer;
        border-radius: var(--r5-radius-md);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .close:hover {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
      }

      .close:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: var(--r5-focus-ring-offset);
      }

      .close svg {
        width: 1.25rem;
        height: 1.25rem;
      }

      /* Content */
      .content {
        flex: 1;
        overflow-y: auto;
        padding: var(--r5-space-6);
      }

      /* Footer */
      .footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: var(--r5-space-3);
        padding: var(--r5-space-6);
        padding-top: 0;
      }

      .footer:empty {
        display: none;
      }

      /* Prevent body scroll */
      :host([open]) {
        overflow: hidden;
      }

      @media (prefers-reduced-motion: reduce) {
        .overlay,
        .dialog {
          transition: none;
        }
      }
    `
];
o([
  u(".dialog")
], t.prototype, "dialogElement", 2);
o([
  u(".overlay")
], t.prototype, "overlayElement", 2);
o([
  i({ type: Boolean, reflect: !0 })
], t.prototype, "open", 2);
o([
  i({ type: String, attribute: "title" })
], t.prototype, "dialogTitle", 2);
o([
  i({ type: String })
], t.prototype, "description", 2);
o([
  i({ type: String, reflect: !0 })
], t.prototype, "size", 2);
o([
  i({ type: Boolean, attribute: "show-close" })
], t.prototype, "showClose", 2);
o([
  i({ type: Boolean, attribute: "close-on-overlay" })
], t.prototype, "closeOnOverlay", 2);
o([
  i({ type: Boolean, attribute: "close-on-escape" })
], t.prototype, "closeOnEscape", 2);
t = o([
  g("ark-dialog")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-dialog-Dmcxt2hX.js.map
